import { FC } from 'react';
import { Trans } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type HomeContentSectionProps = {
  className?: string;
};

export const HomeContentSection: FC<HomeContentSectionProps> = ({ className }) => {
  return (
    <div className={twMerge('flex flex-col gap-6 pt-12', className)}>
      <div className='space-y-4'>
        <h1 className='text-6xl font-bold tracking-tight text-quaternary-900'>
          <Trans
            i18nKey='home:title'
            components={{
              br: <br />,
              blueWord: <span className='text-brand-600'></span>,
            }}
          />
        </h1>
      </div>

      <p className='text-2xl text-quaternary-700'>
        <Trans
          i18nKey='home:description'
          components={{
            br: <br />,
            blueWord: <span className='font-semibold text-brand-600'></span>,
          }}
        />
      </p>
    </div>
  );
};
